// import { Navigate, Outlet } from 'react-router-dom'
// import { useAuth } from '../context/AuthContext'
// import Sidebar from '../components/ui/layout/Sidebar'

// const ProtectedRoute = ({ allowedRoles }) => {
//   const { user, loading } = useAuth()

//   if (loading) return <div className="p-8 text-center">Loading...</div>
//   if (!user) return <Navigate to="/login" replace />
//   if (allowedRoles && !allowedRoles.includes(user.role)) return <Navigate to="/" replace />

//   return (
//     <div className="flex">
//       <Sidebar />
//       <div className="flex-1 ml-64 p-6">
//         <Outlet />
//       </div>
//     </div>
//   )
// }

// export default ProtectedRouteA

// frontend/src/components/ProtectedRoute.jsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ allowedRoles = [] }) => {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (
    user.termsAccepted === false &&
    location.pathname !== "/accept-policies"
  ) {
    return (
      <Navigate
        to="/accept-policies"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;